import { Stack, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function SocialAccountOption({ count, onChange, price, currencySymbol, max, disabled = false }) {
  const { t } = useTranslation();
  return (
    <Stack spacing={1}>
      <TextField
        type="number"
        label={t('billing.social_accounts.title', { defaultValue: 'Social media accounts' })}
        value={count}
        disabled={disabled}
        inputProps={{ min: 0, max, step: 1 }}
        onChange={(event) => {
          const value = Number(event.target.value);
          if (Number.isFinite(value)) onChange(Math.min(max, Math.max(0, Math.floor(value))));
        }}
      />
      <Typography variant="body2" color="text.secondary">
        {t('billing.social_accounts.description', {
          defaultValue: '{{price}} once per account. Shared across Facebook, Instagram, and WhatsApp.',
          price: `${currencySymbol}${Number(price || 0).toLocaleString('en-US')}`,
        })}
      </Typography>
    </Stack>
  );
}
